import { CSSProperties, ReactElement, useEffect } from "react";
import { CheckValueType, IPanelProps, IRMCheckList } from "./types";
import RowComponent from "../../../components/rowComponent";
import { Paper, ToggleButton, ToggleButtonGroup } from "@mui/material";

const heatGridStyle = {
  gridTemplateColumns: "1fr 1fr 1fr"
};

const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)"
});

interface IRow {
  field: keyof IRMCheckList;
  title: string;
}

const rows: IRow[] = [
  { field: "guBurnInIntermediateMillCheckList_8_15_2023", title: "guBurn in Intermediate Mill Check List 8_15_2023" },
  { field: "checkListAfterCobbles", title: "Check list after cobbles" },
  { field: "checkListPassChangeNtm_rev_2", title: "CHECK LIST PASS CHANGE NTM Rev.2" },
  { field: "checkListWithBarInTheMill_2024", title: "Check list with bar in the mill 2024" },
  { field: "intermediateMillChecklist_2024", title: "Intermediate mill checklist 2024" },
  { field: "mainPulpitCheckSheet_rev2", title: "Main Pulpit Check Sheet Rev2" },
  { field: "startupChecks", title: "Startup Checks" }
]

const RmCheckList = ({ value, property, onChange }: IPanelProps<IRMCheckList | undefined>): ReactElement => {

  useEffect(() => {
    if (!value) {
      onChange(property, {
        guBurnInIntermediateMillCheckList_8_15_2023: CheckValueType.NONE,
        checkListAfterCobbles:  CheckValueType.NONE,
        checkListPassChangeNtm_rev_2:  CheckValueType.NONE,
        checkListWithBarInTheMill_2024:  CheckValueType.NONE,
        intermediateMillChecklist_2024:  CheckValueType.NONE,
        mainPulpitCheckSheet_rev2:  CheckValueType.NONE,
        startupChecks: CheckValueType.NONE,
      });
    }
  }, [value, property, onChange]);

  const onRowChanged = (field: keyof IRMCheckList, v: CheckValueType) => {
    if(value) {
      onChange(property, {
        ...value,
        [field]: v
      });
    }
  }

  return (
    <div>
      <Paper elevation={0} className="display-grid mb-1" style={{ padding: ".5em", background: "rgba(50, 50, 50, .3)" }}>
        <div className="align-self-center justify-self-center display-flex-column">
          <strong>ROLLING MILL KEY CHECKLIST PROCESS</strong>
        </div>
      </Paper>

      {/*<RowComponent title="Check List" >*/}
      {/*  <div className="display-grid gap-1" style={heatGridStyle}>*/}
      {/*    <Paper elevation={0}  style={titleCellStyle()} className="display-grid">*/}
      {/*      <div className="align-self-center justify-self-center display-flex-column">*/}
      {/*        <strong>YES</strong>*/}
      {/*      </div>*/}
      {/*    </Paper>*/}
      {/*    <Paper elevation={0}  style={titleCellStyle()} className="display-grid">*/}
      {/*      <div className="align-self-center justify-self-center display-flex-column">*/}
      {/*        <strong>NO</strong>*/}
      {/*      </div>*/}
      {/*    </Paper>*/}
      {/*    <Paper elevation={0}  style={titleCellStyle()} className="display-grid">*/}
      {/*      <div className="align-self-center justify-self-center display-flex-column">*/}
      {/*        <strong>N/A</strong>*/}
      {/*      </div>*/}
      {/*    </Paper>*/}
      {/*  </div>*/}
      {/*</RowComponent>*/}

      {rows.map((row, index) => {
        const item = value ? value[row.field] : CheckValueType.NONE;

        return (
          <RowComponent key={`check-list-${row.field}-${index}`} title={row.title} >
            <ToggleButtonGroup
              color="primary"
              value={item}
              exclusive
              fullWidth
              onChange={(_e, v) => onRowChanged(row.field, v)}>
              <ToggleButton value={CheckValueType.YES}>YES</ToggleButton>
              <ToggleButton value={CheckValueType.NO}>NO</ToggleButton>
              <ToggleButton value={CheckValueType.NA}>N/A</ToggleButton>
              <ToggleButton value={CheckValueType.NONE} style={{ display: "none" }}>NONE</ToggleButton>
            </ToggleButtonGroup>
          </RowComponent>
        );
      })}
    </div>
  );
}

export default RmCheckList;